document.addEventListener('DOMContentLoaded', function () {
  var navToggle = document.querySelector('[data-nav-toggle]');
  var siteNav = document.querySelector('[data-site-nav]');
  var navOverlay = document.querySelector('[data-nav-overlay]');

  function closeNav() {
    if (siteNav) siteNav.classList.remove('is-open');
    if (navToggle) { navToggle.classList.remove('is-active'); navToggle.setAttribute('aria-expanded', 'false'); }
    if (navOverlay) navOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  function openNav() {
    if (siteNav) siteNav.classList.add('is-open');
    if (navToggle) { navToggle.classList.add('is-active'); navToggle.setAttribute('aria-expanded', 'true'); }
    if (navOverlay) navOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  if (navToggle && siteNav) {
    navToggle.addEventListener('click', function () {
      if (siteNav.classList.contains('is-open')) closeNav(); else openNav();
    });
  }
  if (navOverlay) navOverlay.addEventListener('click', closeNav);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeNav();
  });
  if (siteNav) {
    siteNav.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', closeNav);
    });
  }

  /* Sticky header shrink-on-scroll */
  var siteHeader = document.querySelector('.site-header');
  if (siteHeader) {
    var onHeaderScroll = function () {
      siteHeader.classList.toggle('is-scrolled', window.scrollY > 8);
    };
    onHeaderScroll();
    window.addEventListener('scroll', onHeaderScroll, { passive: true });
  }

  /* Back-to-top button */
  var backToTop = document.querySelector('[data-back-to-top]');
  if (backToTop) {
    window.addEventListener('scroll', function () {
      backToTop.classList.toggle('is-visible', window.scrollY > 500);
    }, { passive: true });
    backToTop.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  /* Scroll-reveal for cards/tiles */
  var revealTargets = document.querySelectorAll('.trust-item,.icon-card,.product-card,.testimonial-card,.blog-card,.category-tile');
  if ('IntersectionObserver' in window && revealTargets.length) {
    var counters = new WeakMap();
    var revealObserver = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var parent = el.parentElement;
        var index = counters.get(parent) || 0;
        el.style.transitionDelay = Math.min(index, 5) * 80 + 'ms';
        counters.set(parent, index + 1);
        el.classList.add('is-visible');
        obs.unobserve(el);
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    revealTargets.forEach(function (el) { revealObserver.observe(el); });
  } else {
    revealTargets.forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* Animated stat counters */
  var counterTargets = document.querySelectorAll('.story__stat strong, .hero__badge strong, .perks__pill strong');
  function animateCounter(el) {
    var raw = el.textContent.trim();
    var match = raw.match(/^([\d,.]+)(.*)$/);
    if (!match) return;
    var target = parseFloat(match[1].replace(/,/g, ''));
    var suffix = match[2] || '';
    if (isNaN(target)) return;
    var duration = 1100;
    var start = null;
    function step(ts) {
      if (start === null) start = ts;
      var progress = Math.min((ts - start) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      var value = Math.round(target * eased);
      el.textContent = value + suffix;
      if (progress < 1) requestAnimationFrame(step);
      else el.textContent = raw;
    }
    requestAnimationFrame(step);
  }
  if ('IntersectionObserver' in window && counterTargets.length) {
    var counterObserver = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        animateCounter(entry.target);
        obs.unobserve(entry.target);
      });
    }, { threshold: 0.6 });
    counterTargets.forEach(function (el) { counterObserver.observe(el); });
  }

  /* Footer accordion (mobile only) */
  document.querySelectorAll('[data-footer-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (window.innerWidth > 860) return;
      var col = btn.closest('.footer-col');
      if (col) col.classList.toggle('is-open');
    });
  });

  /* Mobile sticky add-to-cart bar */
  var mainAtcBtn = document.querySelector('[data-product-form] button[type="submit"]');
  var mobileBar = document.querySelector('[data-mobile-atc-bar]');
  if (mainAtcBtn && mobileBar && 'IntersectionObserver' in window) {
    var atcObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        mobileBar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      });
    }, { threshold: 0 });
    atcObserver.observe(mainAtcBtn);
    var mobileBarBtn = mobileBar.querySelector('[data-mobile-atc-submit]');
    if (mobileBarBtn) {
      mobileBarBtn.addEventListener('click', function () {
        mainAtcBtn.click();
      });
    }
  }

  var cartDrawer = document.querySelector('[data-cart-drawer]');
  var cartOpeners = document.querySelectorAll('[data-cart-open]');
  var cartClosers = document.querySelectorAll('[data-cart-close]');

  function openCart() {
    if (cartDrawer) cartDrawer.classList.add('is-open');
  }
  function closeCart() {
    if (cartDrawer) cartDrawer.classList.remove('is-open');
  }
  cartOpeners.forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      openCart();
    });
  });
  cartClosers.forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      closeCart();
    });
  });

  function renderCartDrawer(cart) {
    var body = document.querySelector('[data-cart-body]');
    var foot = document.querySelector('[data-cart-foot]');
    var countEls = document.querySelectorAll('[data-cart-count]');
    countEls.forEach(function (el) {
      var changed = el.textContent !== String(cart.item_count);
      el.textContent = cart.item_count;
      if (changed) {
        el.classList.add('is-bump');
        setTimeout(function () { el.classList.remove('is-bump'); }, 220);
      }
    });

    if (!body) return;

    if (cart.item_count === 0) {
      body.innerHTML = '<p class="cart-drawer__empty">Your cart is empty. Add some ghee to get started.</p>';
      if (foot) foot.innerHTML = '';
      return;
    }

    var html = '';
    cart.items.forEach(function (item) {
      html += '' +
        '<div class="cart-line">' +
        '<img src="' + item.image + '" alt="' + item.product_title + '">' +
        '<div>' +
        '<div class="cart-line__title">' + item.product_title + '</div>' +
        '<div class="cart-line__price">Qty ' + item.quantity + ' &middot; ' + formatMoney(item.final_line_price) + '</div>' +
        '</div>' +
        '</div>';
    });
    body.innerHTML = html;

    if (foot) {
      foot.innerHTML = '' +
        '<div class="cart-subtotal"><span>Subtotal</span><span>' + formatMoney(cart.total_price) + '</span></div>' +
        '<a href="/checkout" class="btn btn-primary btn-block">Checkout</a>';
    }
  }

  function formatMoney(cents) {
    return '₹' + (cents / 100).toLocaleString('en-IN', { minimumFractionDigits: 0 });
  }

  function refreshCart() {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(renderCartDrawer)
      .catch(function () {});
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('[data-add-to-cart-form]')) return;
    e.preventDefault();
    var formData = new FormData(form);
    fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: { Accept: 'application/json' }
    })
      .then(function (res) { return res.json(); })
      .then(function () {
        refreshCart();
        openCart();
      })
      .catch(function () {});
  });

  document.addEventListener('click', function (e) {
    var stepper = e.target.closest('[data-qty-decrease],[data-qty-increase]');
    if (!stepper) return;
    var wrapper = stepper.closest('.qty-stepper');
    var input = wrapper.querySelector('input[type="number"]');
    var value = parseInt(input.value || '1', 10);
    if (stepper.hasAttribute('data-qty-decrease')) value = Math.max(1, value - 1);
    if (stepper.hasAttribute('data-qty-increase')) value = value + 1;
    input.value = value;
  });

  refreshCart();

  var productForm = document.querySelector('[data-product-form]');
  if (productForm) {
    var variantsScript = productForm.querySelector('[data-product-variants]');
    var variants = variantsScript ? JSON.parse(variantsScript.textContent) : [];
    var variantIdInput = productForm.querySelector('[data-variant-id-input]');
    var pickers = productForm.querySelectorAll('.variant-picker');

    function currentSelection() {
      var selected = [];
      pickers.forEach(function (picker) {
        var active = picker.querySelector('.variant-pill.is-active');
        selected.push(active ? active.getAttribute('data-value') : null);
      });
      return selected;
    }

    function findVariant(selected) {
      return variants.find(function (v) {
        return selected.every(function (val, i) {
          return val === null || v.options[i] === val;
        });
      });
    }

    function updatePriceUI(variant) {
      if (!variant) return;
      var priceEl = productForm.querySelector('[data-price]');
      var compareEl = productForm.querySelector('[data-compare-price]');
      var saveBadge = productForm.querySelector('[data-save-badge]');
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      var mobilePriceEl = document.querySelector('[data-mobile-price]');
      if (mobilePriceEl) mobilePriceEl.textContent = formatMoney(variant.price);
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        if (compareEl) { compareEl.textContent = formatMoney(variant.compare_at_price); compareEl.style.display = ''; }
        if (saveBadge) { saveBadge.textContent = 'Save ' + formatMoney(variant.compare_at_price - variant.price); saveBadge.style.display = ''; }
      } else {
        if (compareEl) compareEl.style.display = 'none';
        if (saveBadge) saveBadge.style.display = 'none';
      }
      var submitBtn = productForm.querySelector('button[type="submit"]');
      if (submitBtn) {
        submitBtn.disabled = !variant.available;
        submitBtn.textContent = variant.available ? 'Add to Cart' : 'Sold out';
      }
      var mobileSubmitBtn = document.querySelector('[data-mobile-atc-submit]');
      if (mobileSubmitBtn) {
        mobileSubmitBtn.disabled = !variant.available;
        mobileSubmitBtn.textContent = variant.available ? 'Add to Cart' : 'Sold out';
      }
    }

    pickers.forEach(function (picker) {
      picker.addEventListener('click', function (e) {
        var pill = e.target.closest('.variant-pill');
        if (!pill) return;
        picker.querySelectorAll('.variant-pill').forEach(function (p) { p.classList.remove('is-active'); });
        pill.classList.add('is-active');
        var variant = findVariant(currentSelection());
        if (variant) {
          variantIdInput.value = variant.id;
          updatePriceUI(variant);
        }
      });
    });
  }
});
